import React from 'react';
import PropTypes from 'prop-types';
import Body from '@package/components/Blocks/ExperiencesSearch/Body';
import { SidebarPortal } from '@plone/volto/components';

import Sidebar from '@package/components/Blocks/ExperiencesSearch/Sidebar';

const Edit = ({ data, id, block, onChangeBlock, selected, pathname }) => {
  return (
    <div className="experiences-search">
      <Body
        data={data}
        isEditMode={true}
        onChangeBlock={onChangeBlock}
        block={block}
        id={id}
      />

      <SidebarPortal selected={selected}>
        <Sidebar data={data} block={block} onChangeBlock={onChangeBlock} />
      </SidebarPortal>
    </div>
  );
};
/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Edit.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  id: PropTypes.string.isRequired,
  block: PropTypes.string.isRequired,
  selected: PropTypes.any,
  intl: PropTypes.any,
  onChangeBlock: PropTypes.func.isRequired,
};

export default Edit;
